import React from 'react';
import Spinner from '@stubhub/react-spinner';

function Loader({loading, loadingText, children}) {
  if (typeof loading === 'boolean') {
    if (loading) {
      return (
        <div className="Spinner__container">
          <Spinner />
          {loadingText && <p className="Spinner__LoadingText">{loadingText}</p>}
        </div>
      );
    } else {
      return children;
    }
  }
  return null;
}

export default Loader;
